// Editors with work that exists only in the page, for the things that leave
// the page WITHOUT unloading it.
//
// An editor's `beforeunload` guard covers a reload, a closed tab and a typed
// address — the browser asks. It does not cover leaving from inside the app:
// the side menu's Log out calls signOut(), the router swaps the screen for the
// sign-in page, and no unload ever happens, so the edits simply vanish. That
// is how an operator lost a half-finished Choose your Experience screen.
//
// So an editor registers here while it is mounted, and whatever navigates
// away in-app asks first. Opt-in: an editor that never registers behaves
// exactly as before.
//
//   const unregister = registerUnsavedChanges({
//       label: 'the Choose your Experience screen',
//       isDirty: () => this.hasUnsavedChanges()
//   });
//   // …and call unregister() when the editor unmounts.

const guards = new Set();

/**
 * @param guard  { label: what has unsaved work, as it reads after "changes to",
 *                 isDirty: () => boolean }
 * @returns a function that removes the guard again
 */
export function registerUnsavedChanges(guard) {
    if (!guard || typeof guard.isDirty !== 'function') return () => {};
    guards.add(guard);
    return () => { guards.delete(guard); };
}

/**
 * The labels of every registered editor that has unsaved work right now. A
 * guard that throws counts as clean: a broken check must never trap someone
 * on the page.
 */
export function unsavedWork() {
    const labels = [];
    guards.forEach(guard => {
        let dirty = false;
        try {
            dirty = !!guard.isDirty();
        } catch (e) {
            dirty = false;
        }
        if (dirty) labels.push(guard.label || 'this page');
    });
    return labels;
}
